<template functional>
  <div :style="{ color: `#${$options.methods.getStatusColor(props)}` }">
    {{ $options.methods.getStatusLabel(props) }}
  </div>
</template>

<script>
export default {
  name: 'MiaDatatableCarStatusColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    getStatusLabel({ row, column }) {
      const status = column.meta.statusOptions().find(({ id }) => parseInt(id, 10) === parseInt(row[column.field], 10))

      return status ? status.title : ''
    },

    getStatusColor({ row, column }) {
      const status = column.meta.statusOptions().find(({ id }) => parseInt(id, 10) === parseInt(row[column.field], 10))

      return status ? status.color : '000'
    }
  }
}
</script>
